/** @fileoverview Empty/error state for the student "My tasks" list. */

import { Box, Stack, Text } from '@mantine/core'
import { IconArticleOff } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export type EmptyVariant = 'no_tasks' | 'no_results' | 'error'

interface StudentTasksEmptyStateProps {
  variant: EmptyVariant
}

const KEYS: Record<EmptyVariant, { title: string; text: string }> = {
  no_tasks: { title: 'student_tasks.empty.no_tasks_title', text: 'student_tasks.empty.no_tasks_description' },
  no_results: { title: 'student_tasks.empty.no_results_title', text: 'student_tasks.empty.no_results_description' },
  error: { title: 'student_tasks.empty.error_title', text: 'student_tasks.empty.error_description' },
}

const CONTAINER_STYLE = {
  border: '1px dashed var(--mantine-color-gray-5, #adb5bd)',
  borderRadius: 12,
  backgroundColor: 'var(--mantine-color-gray-1, #f8f9fa)',
}

export function StudentTasksEmptyState({ variant }: StudentTasksEmptyStateProps) {
  const { t } = useTranslation()
  const { title, text } = KEYS[variant]

  return (
    <Box p="xl" style={CONTAINER_STYLE}>
      <Stack align="center" spacing={8}>
        <IconArticleOff size={24} color="#868e96" stroke={1.8} />
        <Text weight={600} align="center" size="md">{t(title)}</Text>
        <Text color="dimmed" align="center" size="md">{t(text)}</Text>
      </Stack>
    </Box>
  )
}
